import { useMutation, useQueryClient } from '@tanstack/react-query'
import { useFetchWithAuth } from '../session/useFetchWithAuth'
import { getCleanThreadId } from '../views/AppNavigator/Messages/helpers'
import { MarkThreadReadResponse } from './types'
import toast from 'react-hot-toast'

const URL = import.meta.env.VITE_EPC_API_URL ?? ''

export const useMarkThreadReadMutation = () => {
  const fetchWithAuth = useFetchWithAuth()
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: async (thread_id: string) => {
      try {
        const cleanThreadId = getCleanThreadId(thread_id)
        const response = await fetchWithAuth(
          `${URL}/threads/${cleanThreadId}/read`,
          {
            method: 'PUT',
            headers: { 'Content-Type': 'application/json' },
          }
        )

        return response as MarkThreadReadResponse
      } catch (error) {
        console.error(`Error marking thread ${thread_id} as read:`, error)
        // No toast needed for this operation as it's a background task
        throw error
      }
    },
    onSuccess: (data) => {
      // Invalidate the specific thread query
      queryClient.invalidateQueries({
        queryKey: ['thread', data.thread_id],
      })

      // Invalidate threads list to update unread counts
      queryClient.invalidateQueries({
        queryKey: ['threads'],
      })
    },
    onError: (error) => {
      console.error('Error marking thread as read:', error)
      // Silent failure - no need to show toast for this background operation
    },
  })
}
